import type { RouteLocationNormalizedGeneric } from '#vue-router'
import type { ChangelogListSource } from '../model/interfaces'

import { MAX_PER_PAGE, getFirstQueryValue, toPaginationValue } from '@shared/lib/routes'

import { useChangelogStore } from '../model/store'

/** Query → store filters for any changelog list; `source` picks which list the table reads. */
export const useMiddlewareChangelogQuery = (to: RouteLocationNormalizedGeneric, source: ChangelogListSource | null): void => {
  const store = useChangelogStore()

  store.setListSource(source)
  store.setFilterSearch(getFirstQueryValue(to.query?.query) || null)
  store.setFilterFrom(getFirstQueryValue(to.query?.from) || null)
  store.setFilterTo(getFirstQueryValue(to.query?.to) || null)
  store.setPerPage(toPaginationValue(to.query?.per_page, store.getPerPage, MAX_PER_PAGE))
  store.setCursor(getFirstQueryValue(to.query?.cursor) || null)
}
